import { CHANGE_SIDENAV } from './types'

export const changeSidenav = (sidenav) => {
  return {
    type: CHANGE_SIDENAV,
    payload: sidenav,
  }
}
